(function($) {

    // Initialize slider on mobile only
    // Carousel for Projects // Blog Articles
    $(window).on('load resize orientationchange', function() {
        $('.slick-slider').slick('refresh');
        $('.slick-slider').slick('setPosition');
        $('.slider-xs').each(function() {
            var $carousel = $(this);
            if (!$carousel.hasClass('slick-initialized')) {
                $('.slider-xs')
                    .on('beforeChange init', function(e, slick, curr, next) {
                        const
                            count = slick.slideCount,
                            show = slick.options.slidesToShow,
                            center = slick.options.centerMode,
                            index = (next | 0) - center * (count > show ? show / 2 | 0 : 0),
                            selector = shift => `[data-slick-index="${index + shift * count}"]`;
                        console.log($('.slider').width());
                        $('.slick-xxx', this).removeClass('slick-xxx');
                        $([ 0, 1, -1 ].map(selector).join(', '), this).addClass('slick-xxx');
                    })
                $carousel.slick({
                    dots: false,
                    arrows: true,
                    accessibility: false,
                    centerPadding: '0px',
                    respondTo: 'slider',
                    draggable: true,
                    mobileFirst: true,
                    slide: '.slider-item',
                    focusOnSelect: true,
                    responsive: [
                        {
                            breakpoint: 1050,
                            settings: {
                                arrows:true,
                                slidesToShow: 5,
                                draggable: true,
                                slidesToScroll: 1
                            }
                        },
                        {

                            breakpoint: 687,
                            settings: {
                                arrows:true,
                                slidesToShow: 3,
                                centerPadding: '0px',
                                slidesToScroll: 1
                            }
                        }
                    ]
                })

                /*Adds inline height on slide for equal height setup*/
                .on('setPosition', function (event, slick) {
                    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
                });
            }
        });
    });

    // Sets width of slider nested inside of tabs
    $('a[data-toggle="pill"]').on('shown.bs.tab', function(e) {
        $('.slick-slider').slick('setPosition');
    });


    $('#site-navigation .menu-toggle').on('click', function() {
        $('.slick-slider').slick('refresh');
        $('.slider').toggleClass('show-sidebar-slider');
        return false;
    });

    // Sets slider height on load*/
    $(window).on('load resize', function() {
        $('.slick-slider').slick('refresh');
        $('.slick-slider').slick('setPosition');
    });

    $('.slider-item').click(function(e) {
        e.preventDefault();
        var slideno = $(this).attr('data-slick-index');
        if ($(window).width() > 1450) {
            $('.slick-slider').slick('slickGoTo', slideno - 2);
        }else{
            $('.slick-slider').slick('slickGoTo', slideno - 1);
        }
    });


}(jQuery));